<template>
    <div class="gallery container-div">
        <h1 class="small-h1 press-h1">FOR THE PRESS</h1>
        <p class="press-p">Download the Creature Fear Press Notes <a href="/Creature_Fear_PressKit.pdf" target="_blank" class="press-notes-link">here</a></p>
        <div class="gallery-row">
            <img class="gallery-img" src="../assets/gallery/1.jpg" alt="1">
            <img class="gallery-img" src="../assets/gallery/2.jpg" alt="2">
        </div>
        <div class="gallery-row">
            <img class="gallery-img" src="../assets/gallery/3.jpg" alt="3">
            <img class="gallery-img" src="../assets/gallery/4.jpg" alt="4">
        </div>
        <div class="gallery-row">
            <img class="gallery-img" src="../assets/gallery/5.jpg" alt="5">
            <img class="gallery-img" src="../assets/gallery/6.jpg" alt="6">
        </div>
        <div class="gallery-row">
            <img class="gallery-img" src="../assets/gallery/7.jpg" alt="7">
            <img class="gallery-img" src="../assets/gallery/8.jpg" alt="8">
        </div>
        <div class="gallery-row">
            <img class="gallery-img" src="../assets/gallery/9.jpg" alt="9">
            <img class="gallery-img" src="../assets/gallery/10.jpg" alt="10">
        </div>
        <div class="gallery-row">
            <img class="gallery-img" src="../assets/gallery/12.jpg" alt="12">
            <img class="gallery-img" src="../assets/gallery/13.jpg" alt="13">
        </div>
        <div class="gallery-row">
            <img class="gallery-img" src="../assets/gallery/14.jpg" alt="14">
            <img class="gallery-img" src="../assets/gallery/15.jpg" alt="15">
        </div>
        <div class="gallery-row">
            <img class="gallery-img" src="../assets/gallery/16.jpg" alt="16">
            <img class="gallery-img" src="../assets/gallery/17.jpg" alt="17">
        </div>
        <div class="gallery-row">
            <img class="gallery-img" src="../assets/gallery/18.jpg" alt="18">
            <img class="gallery-img" src="../assets/gallery/20.jpg" alt="20">
        </div>
        <div class="gallery-row">
            <img class="gallery-img" src="../assets/gallery/21.jpg" alt="21">
            <img class="gallery-img" src="../assets/gallery/22.jpg" alt="22">
        </div>
        <div class="gallery-row">
            <img class="gallery-img" src="../assets/gallery/23.jpg" alt="23">
            <img class="gallery-img" src="../assets/gallery/24.jpg" alt="24">
        </div>
        <div class="gallery-row">
            <img class="gallery-img" src="../assets/gallery/25.jpg" alt="25">
            <img class="gallery-img" src="../assets/gallery/26.jpg" alt="26">
        </div>
        <div class="gallery-row">
            <img class="gallery-img" src="../assets/gallery/27.jpg" alt="27">
            <img class="gallery-img" src="../assets/gallery/28.jpg" alt="28">
        </div>
        <div class="gallery-row">
            <img class="gallery-img" src="../assets/gallery/29.jpg" alt="29">
            <img class="gallery-img" src="../assets/gallery/32.jpg" alt="32">
        </div>
        <div class="gallery-row">
            <img class="gallery-img" src="../assets/gallery/33.jpg" alt="33">
            <img class="gallery-img" src="../assets/gallery/34.jpg" alt="34">
        </div>
        <div class="gallery-row">
            <img class="gallery-img" src="../assets/gallery/35.jpg" alt="35">
            <img class="gallery-img" src="../assets/gallery/36.jpg" alt="36">
        </div>
        <div class="gallery-row">
            <img class="gallery-img" src="../assets/gallery/37.jpg" alt="37">
            <img class="gallery-img" src="../assets/gallery/38.jpg" alt="38">
        </div>
        <div class="gallery-row">
            <img class="gallery-img" src="../assets/gallery/39.jpg" alt="39">
            <img class="gallery-img" src="../assets/gallery/40.jpg" alt="40">
        </div>
        <div class="gallery-row">
            <img class="gallery-img" src="../assets/gallery/43.jpg" alt="43">
            <img class="gallery-img" src="../assets/gallery/45.jpg" alt="45">
        </div>
        <div class="gallery-row">
            <img class="gallery-img" src="../assets/gallery/46.jpg" alt="46">
            <img class="gallery-img" src="../assets/gallery/47.jpg" alt="47">
        </div>
    </div>
</template>

<script setup>
</script>
